'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrow = require('../../utils/arrow');

// Ideally, this should be 15px,
// but because of browser rendering inconsistencies, I added a little buffer.
var ARROW_BASE = 15.5;

// Browsers have issues with partial pixels and cause the Popover Arrow to render
// _slightly_ off. The 1px offset here is to accommodate for that.
var BROWSER_OFFSET = 1;

exports.default = _extends({
  ARROW_BASE: ARROW_BASE,
  BROWSER_OFFSET: BROWSER_OFFSET
}, (0, _arrow.generateConstants)({ ARROW_BASE: ARROW_BASE, BROWSER_OFFSET: BROWSER_OFFSET }));


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Popover/constants.js
// module id = 730
// module chunks = 2